import { render, staticRenderFns } from "./warehousemenu.vue?vue&type=template&id=0d1f0556&scoped=true&"
import script from "./warehousemenu.vue?vue&type=script&lang=js&"
export * from "./warehousemenu.vue?vue&type=script&lang=js&"
import style0 from "./warehousemenu.vue?vue&type=style&index=0&id=0d1f0556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1f0556",
  null
  
)

export default component.exports